// MobileSheetListSheet — bottom-sheet med en lista över alla sheets i
// multi-sheet-workflowet. Tap → setActiveSheetIndex.
//
// Triggas av engicoro:open-sheet-list custom event (vilken canvas-touch
// dispatchar vid 1-finger 3× tap på tom canvas).

import { Sheet, SheetContent, SheetTitle, SheetDescription } from '@/components/ui/sheet';
import { Layers, Check } from 'lucide-react';
import { useWorkflow } from '@/contexts/WorkflowContext';

interface MobileSheetListSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MobileSheetListSheet({ open, onOpenChange }: MobileSheetListSheetProps) {
  const wf = useWorkflow();

  const handlePick = (index: number) => {
    wf.setActiveSheetIndex(index);
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="max-h-[60vh]">
        <SheetTitle className="text-sm flex items-center gap-2">
          <Layers className="w-4 h-4" />
          Välj sheet
        </SheetTitle>
        <SheetDescription className="text-xs">
          {wf.sheets.length} sheets totalt
        </SheetDescription>

        <ul className="mt-3 space-y-1 overflow-y-auto">
          {wf.sheets.map((sheet, idx) => {
            const isActive = idx === wf.activeSheetIndex;
            const blockCount = sheet.blocks.length;
            const groupCount = sheet.groups.length;
            const label = sheet.name?.trim() || `Sheet ${idx + 1}`;
            return (
              <li key={sheet.id}>
                <button
                  type="button"
                  onClick={() => handlePick(idx)}
                  className={`flex items-center gap-3 w-full px-3 py-2.5 rounded-md text-left transition-colors ${
                    isActive ? 'bg-primary/10 text-primary' : 'hover:bg-accent'
                  }`}
                  style={{ minHeight: '48px' }}
                >
                  <span className="text-xs font-mono text-muted-foreground flex-shrink-0 w-6">
                    {idx + 1}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium truncate">{label}</div>
                    <div className="text-[11px] text-muted-foreground">
                      {blockCount} block · {groupCount} grupp(er)
                    </div>
                  </div>
                  {isActive && <Check className="w-4 h-4 flex-shrink-0" />}
                </button>
              </li>
            );
          })}
        </ul>
      </SheetContent>
    </Sheet>
  );
}
